import Vue from 'vue'
// Vue.js 3
import UplotVue from './uplot-vue'
import './uplot/uPlot.css'

Vue.component('UplotVue', UplotVue)
